export default __webpack_public_path__ + "static/media/calenderView.4e8f94d3.png";